module.exports = __webpack_public_path__ + "static/media/desktopScreenshot04.60bd16f8.jpg";